import {
  createBrowserRouter,
  RouterProvider,
  Outlet
} from "react-router-dom";

import Home from "./pages/Home";
import Navbar from "./components/Navbar";
import Offerings from "./pages/Programs";
import Footer from "./components/Footer";
import ErrorPage from "./pages/Error";
import Enterprise from "./pages/Enterprise";
import AboutPage from "./pages/About";
import GetInvolvedPage from "./pages/ContactUs";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/ServiceTerms";
import ProgramDetail from "./components/programs/ProgramDetail";
import ApplicationFormPage from "./pages/Apply";
import AdminPage from "./pages/Admin";
import AdminLogin from "./pages/AdminLogin";
import ProtectedRoute from "./components/utils/ProtectedRoute";
import ScrollToTop from "./components/utils/ScrollToTop";
import BlogPage from "./pages/Blog";
import SingleBlogPost from "./components/blog/BlogDetails";
import ScheduleConsultation from "./pages/Consultation";
import ThankYou from "./pages/Thanks";

const Layout = () => {
  return (
    <>
    <Navbar />
    <ScrollToTop />
    <Outlet />
    <Footer />
    </>
  );
};


const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <Layout />,
      children: [
        {
          path: "",
          element: <Home />
        },
        {
          path: "/blog",
          element: <BlogPage />
        },
        {
          path: "/blog/:slug",
          element: <SingleBlogPost />
        },
        {
          path: "/programs",
          element: <Offerings />
        },
        {
          path: "/programs/:slug",
          element: <ProgramDetail  />
        },
        {
          path: "/about",
          element: <AboutPage />
        },
        {
          path: "/contact-us",
          element: <GetInvolvedPage />
        },
        {
          path: "/enterprise",
          element: <Enterprise />
        },
        {
          path: "/apply/:slug",
          element: <ApplicationFormPage />
        },
        {
          path: "/consultation",
          element: <ScheduleConsultation />
        },
        {
          path: "/privacy-policy",
          element: <PrivacyPolicy />
        },
        {
          path: "/terms-of-service",
          element: <TermsOfService />
        },
        {
          path: "/thank-you",
          element: <ThankYou />
        },
        {
          path: "/choosenone",
          element: (
            <ProtectedRoute>
              <AdminPage />
            </ProtectedRoute>
          )
        },
        {
          path: "/login",
          element: <AdminLogin />
        },
        {
          path: "*",
          element: <ErrorPage />
        }
      ]
    },
  ]
);

function App() {
  return (
    <div>
        <RouterProvider router={router} />
    </div>
  );
};

export default App;
